import { __decorate, __metadata } from "tslib";
import { Vue, Component, Ref } from 'vue-property-decorator';
import Icon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/see.svg';
import '@patsnap-ui/icon/assets/solid/NotSee.svg';
let InputImpl = class InputImpl extends Vue {
    constructor() {
        super(...arguments);
        this.passwordVisible = false;
    }
    handlePasswordVisible() {
        this.passwordVisible = !this.passwordVisible;
        this.editInputRef?.handlePasswordVisible();
    }
    focus() {
        this.editInputRef.focus();
    }
};
__decorate([
    Ref(),
    __metadata("design:type", Object)
], InputImpl.prototype, "editInputRef", void 0);
InputImpl = __decorate([
    Component({
        name: 'Input',
        components: {
            PtIcon: Icon,
        },
    })
], InputImpl);
export { InputImpl };
